import { styled } from "@mui/material/styles";

const StyledExperimentInstructions = styled("div")`
  width: 100%;
  box-sizing: border-box;
`;

const StyledExperimentInstructionsHeader = styled("div")`
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: 24px;
  margin-bottom: 40px;

  @media (min-width: 768px) {
    flex-direction: ${({ theme }) =>
      theme.direction === "rtl" ? "row-reverse" : "row"};
    justify-content: space-between;
  }
`;

const StyledExperimentInstructionsSubheader = styled("div")`
  display: flex;
  width: 100%;
  height: 84px;
  flex-direction: row;
  align-items: center;
  padding: 24px 16px;
  background-color: ${({ theme }) => theme.palette.common.white};
  border-radius: 8px;
  margin-bottom: 24px;
  justify-content: ${({ theme }) =>
    theme.direction === "rtl" ? "flex-end" : "flex-start"};

  @media (min-width: 768px) {
    margin-bottom: 16px;
    padding: 24px;
  }
`;

const StyledExperimentInstructionsList = styled("div")`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: center;
  gap: 8px;
`;

const StyledExperimentInstructionsItem = styled("div")`
  display: flex;
  width: 100%;
  flex-direction: column;
  padding: 40px 24px 24px;
  gap: 32px;
  background-color: ${({ theme }) => theme.palette.common.white};
  border-radius: 8px;

  @media (min-width: 768px) {
    flex-direction: ${({ theme }) =>
      theme.direction === "rtl" ? "row-reverse" : "row"};
    align-items: flex-start;
    justify-content: space-between;
    gap: 40px;
    padding: 24px;
  }
`;

const StyledExperimentInstructionsContent = styled("div")`
  display: flex;
  width: 100%;
  flex-direction: ${({ theme }) =>
    theme.direction === "rtl" ? "row-reverse" : "row"};
  align-items: center;
  gap: 16px;
  max-width: 375px;
  justify-content: flex-start;

  @media (min-width: 768px) {
    padding-top: 12px;
  }
`;

const StyledExperimentInstructionsOrder = styled("div")`
  display: flex;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  background-color: ${({ theme }) => theme.palette.green.light};
  font-family: ${({ theme }) => theme.typography.fontFamily};
  font-size: ${({ theme }) => theme.typography.bodyL?.fontSize};
  line-height: ${({ theme }) => theme.typography.bodyL?.lineHeight};
  color: ${({ theme }) => theme.palette.common.black};
  font-weight: 500;
  flex-shrink: 0;
`;

const StyledExperimentInstructionsBorderedContainer = styled("div")`
  display: flex;
  position: relative;
  width: 100%;
  flex-direction: column;
  padding: 16px 24px;
  border: ${({ theme }) => `1px dashed ${theme.palette.customGrey.main}`};
  border-radius: 8px;

  @media (min-width: 1200px) {
    min-width: 400px;
    width: max-content;
    max-width: 50%;

    &.lg {
      width: 50%;
      max-width: 600px;
    }
  }

  & button.blue-bg {
    background-color: rgb(135, 204, 251);
    color: ${({ theme }) => theme.palette.common.white};
    border-color: rgb(135, 204, 251);

    & svg[stroke] {
      stroke: ${({ theme }) => theme.palette.common.white};
    }

    & svg[fill] {
      fill: ${({ theme }) => theme.palette.common.white};
    }
  }

  & > .instructions-field {
    width: 100%;

    & label {
      width: 100%;
    }

    & textarea,
    & label {
      text-align: ${({ theme }) =>
        theme.direction === "rtl" ? "end" : "start"};
    }
  }
`;

const StyledExperimentInstructionsCursor = styled("span")`
  display: flex;
  width: 22px;
  height: 22px;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  position: absolute;

  &.button-cursor {
    right: 30px;
    top: 50%;
    transform: translateY(-50%);
  }

  &.question-cursor {
    right: 16px;
    top: 45px;
  }

  &.test-cursor {
    right: 10%;
    bottom: 40px;
  }

  & > svg {
    width: 100%;
  }
`;

const StyledExperimentInstructionsQuestionContainer = styled("div")`
  display: flex;
  width: 100%;
  flex-direction: column;
  padding: 14px 16px;
  background-color: ${({ theme }) => theme.palette.customGrey.soft};
  border-radius: 8px;
  gap: 7px;
`;

const StyledExperimentInstructionsQuestionHeader = styled("div")`
  display: flex;
  width: 100%;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 10px;

  & > .info-icon {
    display: flex;
    width: 22px;
    height: 22px;
    flex-direction: row;
    align-items: center;
    justify-content: center;

    & > svg {
      width: 100%;
    }
  }
`;

const StyledExperimentInstructionsOptions = styled("div")`
  display: flex;
  width: 100%;
  flex-direction: ${({ theme }) =>
    theme.direction === "rtl" ? "row-reverse" : "row"};
  align-items: center;
  gap: 4px;
`;

const StyledExperimentInstructionsOption = styled("div")`
  display: flex;
  width: max-content;
  min-width: calc(33.333% - 4px);
  height: 70px;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background-color: ${({ theme }) => theme.palette.customGrey.soft};
  border: 1px solid transparent;
  font-family: ${({ theme }) => theme.typography.fontFamily};
  font-size: ${({ theme }) => theme.typography.bodyM?.fontSize};
  line-height: ${({ theme }) => theme.typography.bodyM?.lineHeight};
  color: ${({ theme }) => theme.palette.common.black};
  font-weight: 500;

  &.active {
    background-color: ${({ theme }) => theme.palette.common.white};
    border-color: ${({ theme }) => theme.palette.primary.main};
  }

  &.lg {
    font-size: 32px;
    line-height: ${({ theme }) => theme.typography.h1.lineHeight};
  }
`;

const StyledExperimentProducts = styled("div")`
  width: 100%;
  box-sizing: border-box;
`;

const StyledExperimentProductsHeader = styled("div")`
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: 24px;
  margin-bottom: 24px;

  @media (min-width: 768px) {
    flex-direction: ${({ theme }) =>
      theme.direction === "rtl" ? "row-reverse" : "row"};
    justify-content: space-between;
    align-items: center;
    margin-bottom: 54px;
  }
`;

const StyledExperimentProductsSubheader = styled("div")`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: center;
  padding: 24px 16px;
  background-color: ${({ theme }) => theme.palette.common.white};
  border-radius: 8px;
  margin-bottom: 16px;
  gap: 24px;

  & > .experiment-need-help {
    order: 1;
  }

  & > .experiment-products-headings {
    order: 2;
    max-width: 440px;

    @media (min-width: 768px) {
      width: 50%;
    }
  }

  & > .need-help-info {
    width: 100%;
  }

  @media (min-width: 768px) {
    flex-direction: ${({ theme }) =>
      theme.direction === "rtl" ? "row-reverse" : "row"};
    align-items: flex-start;
    justify-content: space-between;
    padding: 32px 24px;
    flex-wrap: wrap;

    & > .experiment-need-help {
      order: 2;
    }

    & > .experiment-products-headings {
      order: 1;
    }
  }
`;

const StyledExperimentProductsContainer = styled("div")`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: center;
  padding: 24px 16px;
  background-color: ${({ theme }) => theme.palette.common.white};
  border-radius: 8px;
  margin-bottom: 16px;
  gap: 48px;

  @media (min-width: 768px) {
    flex-direction: ${({ theme }) =>
      theme.direction === "rtl" ? "row-reverse" : "row"};
    align-items: center;
    justify-content: space-between;
    padding: 32px 24px;
  }
`;

const StyledExperimentProductsList = styled("div")`
  display: flex;
  width: max-content;
  flex-direction: ${({ theme }) =>
    theme.direction === "rtl" ? "row-reverse" : "row"};
  align-items: center;
  gap: 16px;
`;

const StyledExperimentProductContainer = styled("div")`
  display: flex;
  width: 105px;
  flex-direction: column;
  align-items: center;
  gap: 10px;
`;

const StyledExperimentProduct = styled("div")`
  display: flex;
  width: 100%;
  height: 65px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background-color: ${({ theme }) => theme.palette.customGrey.soft};
`;

const StyledExperimentTasting = StyledExperimentProducts;
const StyledExperimentTastingHeader = StyledExperimentProductsHeader;
const StyledExperimentTastingSubheader = StyledExperimentProductsSubheader;

const StyledExperimentTastingContainer = styled("div")`
  display: flex;
  width: 100%;
  flex-direction: column;
  padding: 24px 16px;
  background-color: ${({ theme }) => theme.palette.common.white};
  border-radius: 8px;
  gap: 32px;
  box-sizing: border-box;

  @media (min-width: 768px) {
    padding: 32px 24px;
  }

  & .questionnaire-text {
    max-width: 50%;
  }
`;

const StyledExperimentTastingBtnsContainer = styled("div")`
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: 16px;
  align-items: center;
  box-sizing: border-box;

  @media (min-width: 768px) {
    flex-direction: row;
    justify-content: justify-content: ${({ theme }) =>
      theme.direction === "rtl" ? "flex-end" : "flex-start"};;
    
  }

  & > .answers-submit {
    @media (min-width: 768px) {
      max-width: 350px;
    }
  }
`;

const StyledExperimentQuestionsInstructionsContainer = styled("div")`
  display: flex;
  width: 100%;
  box-sizing: border-box;

  @media (min-width: 768px) {
    max-width: 50%;
  }

  & > .instructions-field {
    width: 100%;
  }
`;

const StyledExperimentTastingList = styled("div")`
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: 48px;
  box-sizing: border-box;

  @media (min-width: 1024px) {
    gap: 32px;
  }
`;

const StyledExperimentQuestionItem = styled("div")`
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: 8px;
  box-sizing: border-box;

  @media (min-width: 768px) {
    flex-direction: ${({ theme }) =>
      theme.direction === "rtl" ? "row-reverse" : "row"};
    gap: 24px;
    align-items: flex-start;
    justify-content: space-between;
  }

  @media (min-width: 1024px) {
    gap: 48px;
  }
`;

const StyledExperimentQuestionContainer = styled("div")`
  display: flex;
  width: 100%;
  flex-direction: column;
  padding: 16px;
  background-color: ${({ theme }) => theme.palette.customGrey.soft};
  border-radius: 8px;
  gap: 7px;
  box-sizing: border-box;

  @media (min-width: 768px) {
    max-width: 50%;
    padding: 16px 24px;
  }
`;

const StyledExperimentQuestionHeader = styled("div")`
  display: flex;
  width: 100%;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  box-sizing: border-box;

  & .info-icon {
    display: flex;
    width: 22px;
    height: 22px;
    flex-direction: row;
    align-items: center;
    justify-content: center;

    & > svg {
      width: 100%;
    }
  }
`;

const StyledExperimentQuestionOptions = styled("div")`
  display: flex;
  width: 100%;
  flex-direction: ${({ theme }) =>
    theme.direction === "rtl" ? "row-reverse" : "row"};
  align-items: center;
  gap: 6px;
  box-sizing: border-box;

  @media (min-width: 1024px) {
    max-width: 620px;
  }
`;

const StyledExperimentQuestionOption = styled("div")`
  display: flex;
  width: max-content;
  min-width: calc(33.333% - 4px);
  height: 70px;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background-color: ${({ theme }) => theme.palette.customGrey.soft};
  border: 1px solid transparent;
  font-family: ${({ theme }) => theme.typography.fontFamily};
  font-size: ${({ theme }) => theme.typography.bodyM?.fontSize};
  line-height: ${({ theme }) => theme.typography.bodyM?.lineHeight};
  color: ${({ theme }) => theme.palette.common.black};
  font-weight: 500;
  transition: all 0.2s ease;
  box-sizing: border-box;
  cursor: pointer;
  user-select: none;

  @media (min-width: 768px) {
    height: 84px;
  }

  &.active {
    background-color: ${({ theme }) => theme.palette.primary.main};
    color: white;
  }

  &.lg {
    font-size: 32px;
    line-height: ${({ theme }) => theme.typography.h1.lineHeight};
  }

  &:hover {
    transition: all 0.2s ease;
    border-color: ${({ theme }) => theme.palette.primary.main};
  }
`;

export {
  StyledExperimentInstructions,
  StyledExperimentInstructionsHeader,
  StyledExperimentInstructionsSubheader,
  StyledExperimentInstructionsList,
  StyledExperimentInstructionsItem,
  StyledExperimentInstructionsContent,
  StyledExperimentInstructionsOrder,
  StyledExperimentInstructionsBorderedContainer,
  StyledExperimentInstructionsCursor,
  StyledExperimentInstructionsQuestionContainer,
  StyledExperimentInstructionsQuestionHeader,
  StyledExperimentInstructionsOptions,
  StyledExperimentInstructionsOption,
  StyledExperimentProducts,
  StyledExperimentProductsHeader,
  StyledExperimentProductsSubheader,
  StyledExperimentProductsContainer,
  StyledExperimentProductsList,
  StyledExperimentProductContainer,
  StyledExperimentProduct,
  StyledExperimentTasting,
  StyledExperimentTastingHeader,
  StyledExperimentTastingSubheader,
  StyledExperimentTastingContainer,
  StyledExperimentQuestionsInstructionsContainer,
  StyledExperimentTastingBtnsContainer,
  StyledExperimentTastingList,
  StyledExperimentQuestionItem,
  StyledExperimentQuestionContainer,
  StyledExperimentQuestionHeader,
  StyledExperimentQuestionOptions,
  StyledExperimentQuestionOption,
};
